import { Phone, MessageCircle, Mail } from "lucide-react";
import "./DeliveryPersonCard.css";

const DeliveryPersonCard = ({
  name,
  photo,
  phone,
  email,
  vehicleNumber,
  rating,
  deliveriesCompleted,
}) => {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <div className="delivery-person-card">
      <h3 className="delivery-person-card__header">Delivery Partner</h3>
      <div className="delivery-person-card__content">
        <div className="delivery-person-card__avatar-wrapper">
          <div className="delivery-person-card__avatar">
            {photo ? (
              <img
                src={photo}
                alt={name}
                className="delivery-person-card__avatar-image"
              />
            ) : (
              <div className="delivery-person-card__avatar-fallback">
                {initials}
              </div>
            )}
          </div>
        </div>
        <div className="delivery-person-card__info">
          <h4 className="delivery-person-card__name">{name}</h4>
          <div className="delivery-person-card__stats">
            <span className="delivery-person-card__rating">
              ★ {rating.toFixed(1)}
            </span>
            <span className="delivery-person-card__separator">•</span>
            <span className="delivery-person-card__deliveries">
              {deliveriesCompleted} deliveries
            </span>
          </div>
          <p className="delivery-person-card__vehicle">
            Vehicle: {vehicleNumber}
          </p>
        </div>
      </div>
      <div className="delivery-person-card__actions">
        <a
          href={`tel:${phone}`}
          className="delivery-person-card__action-btn delivery-person-card__action-btn--beige"
          aria-label={`Call ${name}`}
        >
          <Phone size={16} className="delivery-person-card__icon" />
          Call
        </a>
        <a
          href={`sms:${phone}`}
          className="delivery-person-card__action-btn delivery-person-card__action-btn--beige"
          aria-label={`Message ${name}`}
        >
          <MessageCircle size={16} className="delivery-person-card__icon" />
          Message
        </a>
        {email && (
          <a
            href={`mailto:${email}`}
            className="delivery-person-card__action-btn delivery-person-card__action-btn--beige"
            aria-label={`Email ${name}`}
          >
            <Mail size={16} className="delivery-person-card__icon" />
            Email
          </a>
        )}
      </div>
    </div>
  );
};

export default DeliveryPersonCard;
